const WEBHOOK_SECRET_KEY = 'webhookSecret'

export function getWebhookSecret(): string {
  return localStorage.getItem(WEBHOOK_SECRET_KEY) || ''
}

export function setWebhookSecret(secret: string): void {
  localStorage.setItem(WEBHOOK_SECRET_KEY, secret)
}

/**
 * Wrapper around fetch that adds the x-webhook-secret header for mutating requests.
 * GET requests pass through without the header.
 */
export function authedFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const method = init?.method?.toUpperCase() || 'GET'
  if (method === 'GET') {
    return fetch(input, init)
  }
  const secret = getWebhookSecret()
  const headers = new Headers(init?.headers)
  if (secret) {
    headers.set('x-webhook-secret', secret)
  }
  return fetch(input, { ...init, headers })
}
